<div [hidden]="mobilesearch" class="tt-nav-bar__actions tt-nav-bar__actions--start">
    <tt-button *ngIf="navBar.backButtonVisible$ | async" ttIcon="fal fa-arrow-left" (ttClick)="state.back()"></tt-button>
    <tt-button ttIcon="fal fa-bars" (click)="sideNav.toggle()"></tt-button>

    <ng-content select="[left]"></ng-content>
    <h1 class="tt-navbar__heading" style="flex: 1; text-align: left">{{ navBar.heading$ | async }}</h1>
</div>

<div *ngIf="!('mobile' | mediaQuery)" #wrapper id="globalsearch">
    <ng-container *ngTemplateOutlet="globalSearch; context: { id: wrapper.id, maxHeight: '40vh' }"></ng-container>
</div>

<div [hidden]="mobilesearch" class="tt-nav-bar__actions tt-nav-bar__actions--end">
    <tt-button *ngIf="'mobile' | mediaQuery" ttIcon="fal fa-search" (ttClick)="setMobileGlobalSearch()"></tt-button>
    <button
        *ngIf="aiChatPanel.canUseAiChat"
        type="button"
        class="tt-nav-bar__ai-button"
        aria-label="AI chat"
        title="AI chat"
        [class.tt-nav-bar__ai-button--active]="aiChatPanel.open$ | async"
        [attr.aria-expanded]="aiChatPanel.open$ | async"
        (click)="aiChatPanel.toggle()"
    >
        <span class="fa-stack tt-nav-bar__ai-icon" aria-hidden="true">
            <i class="fal fa-flower fa-stack-1x"></i>
            <i class="fal fa-flower fa-stack-1x tt-nav-bar__ai-icon--rotated"></i>
        </span>
    </button>
    <tt-button
        [ttIcon]="(theme.themeMode$ | async) === 'light' ? 'fal fa-moon' : 'fal fa-sun'"
        [ttTooltipText]="(theme.themeMode$ | async) === 'light' ? 'switch_to_dark_mode' : 'switch_to_light_mode'"
        (click)="theme.toggleDarkMode()"
    ></tt-button>
    <tt-button ttIcon="fal fa-star" ttTooltipText="navbar_favorites" (ttClick)="modal.openFavouritesDialog()"></tt-button>
    <tt-button
        *ngIf="!('mobile' | mediaQuery)"
        ttIcon="fal fa-play-circle"
        ttTooltipText="navbar_video_help"
        (ttClick)="navBar.openVideoTutorialsDialog('webpage_name', state.getCurrentName())"
    ></tt-button>
    <tt-button ttIcon="fal fa-question-circle" ttTooltipText="navbar_helpdoc" (ttClick)="navBar.openHelpDocDialog(state.getCurrentName())"></tt-button>
    <tt-button
        ttIcon="fal fa-inbox"
        ttTooltipText="navbar_notifications"
        [ttBadge]="((notifications.unreadCount$ | async) ?? 0 > 0) ? '' + (notifications.unreadCount$ | async) : ''"
        (ttClick)="state.go('p2notifications')"
    ></tt-button>
    <tt-button *ngIf="navBar.homeButtonVisible$ | async" ttIcon="fal fa-home-alt" ttTooltipText="navbar_home" (ttClick)="state.go('mainmenu')"></tt-button>
    <tt-button *ngIf="!(navBar.homeButtonVisible$ | async)" ttIcon="fal fa-sign-out" ttTooltipText="sign_out" (ttClick)="state.signOut()"></tt-button>
</div>

<ng-container *ngIf="mobilesearch && ('mobile' | mediaQuery)">
    <ng-container *ngTemplateOutlet="mobileGlobalSearch"></ng-container>
</ng-container>

<ng-template #mobileGlobalSearch>
    <div #wrapperMobile id="globalsearchmobile" style="display: flex; align-items: center; width: 100%" ttOutsideClick (onOutsideClick)="mobilesearch = false" [ignore]="element">
        <tt-button ttIcon="far fa-arrow-left" (ttClick)="mobilesearch = false"></tt-button>
        <ng-container *ngTemplateOutlet="globalSearch; context: { id: wrapperMobile.id, maxHeight: 'calc(100vh - 4rem)' }"></ng-container>
    </div>
</ng-template>

<ng-template #globalSearch let-id="id" let-maxHeight="maxHeight">
    <div class="tt-nav-bar__input-wrapper" style="flex: 1">
        <span class="fa-fw far fa-search tt-nav-bar__input-icon"></span>
        <input
            class="tt-nav-bar__input"
            #mobileInputRef
            type="search"
            autocomplete="nope"
            ttListboxPopup
            [ttRelativeElement]="id"
            [ttMaxHeight]="maxHeight"
            [ttData]="results"
            [formControl]="searchtext$"
            (ttSelect)="onSelect($event)"
            [placeholder]="get?.globalsearch_placeholder ?? ''"
            (focus)="onGlobalSearchFocus()"
        />
        <tt-button [hidden]="!(searchtext$.valueChanges | async)" ttIcon="fal fa-times" (ttClick)="searchtext$.setValue(''); mobileInputRef.focus()"></tt-button>
    </div>
</ng-template>
